import * as yup from 'yup';

const optionalWithPattern = (name, pattern, message) => {
  return yup.string().test(name, message, value => {
    if (!value) return true;  // allow empty
    return pattern.test(value);
  });
};

const merchantSchemaStep3 = yup.object().shape({
  amountPerTrans: yup.string(),
  allowedTotAmtPerDay: yup.string(),
  allowedTransPerDay: yup.string()
});
const merchantSchemaStep2 = yup.object().shape({
  merchantFrequency: yup.string(),

  bankerBranchName: yup.string(),
  accountNo: yup.string(),
  ifscCode: yup.string(),
  expectedCardBusinessPerMonth: yup.string(),
  averageBillAmount: yup.string(),
  turnoverYear1: yup.string()
});

const merchantSchemaStep1 = yup.object().shape({
  referenceId: optionalWithPattern("referenceId", /^[a-zA-Z0-9]{0,5}$/, 'Invalid Reference Code'),

  referenceCompanyName: optionalWithPattern("referenceCompanyName", /^[a-zA-Z0-9!@#$&()-`.+,/" ]*$/, 'Please Enter Valid Reference Company Name')
    .max(50, 'Please Enter Valid Reference Company Name'),

  ownerName: yup.string()
    .required('Owner name is required.')
    .matches(/^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/, 'Invalid Owner Name')
    .max(20, 'Invalid Owner Name'),
  mid: yup.string()
    .required('Merchant id is required.')
    .matches(/^[a-zA-Z0-9]{15}$/, 'Please Enter Valid Merchant ID 15 Alphanumeric and Not use the special characters and spaces'),

  companyName: yup.string()
    .required('Registered Business Name is required.')
    .matches(/^[a-zA-Z0-9!@#$&()-`.+,/\"]*$/, 'Invalid Registered Business Name')
    .max(50, 'Invalid Registered Business Name'),

  typeEstablishment: yup.string()
    .notOneOf(['', '-1'], 'Please select a valid Type of Entity'),

  address: yup.string()
    .max(200, 'Address length exceeds the limit'),

  addressRes: yup.string()
    .max(200, 'Address length exceeds the limit'),

  pinCode: yup.string()
    .test('authorizedPerson', 'Invalid Authorized Person Name', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .matches(/^[0-9]{6}$/, 'Invalid Zip Code'),

  mccCode: yup.string()
    .notOneOf(['', '-1'], 'Please select a valid Merchant Category Code'),

  abn: yup.string()
    .test('abn', 'Invalid ABN', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(30, 'Max length of ABN should be 30.'),

  acn: yup.string()
    .test('acn', 'Invalid ACN', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(30, 'Max length of ACN should be 30.'),

  establishmentYrs: yup.string()
    .test('establishmentYrs', 'Invalid Year. Please use the format XXXX', value => {
      if (!value) return true;  // allow empty
      return /^[0-9]{4}$/.test(value);
    }),

  saleTaxNo: yup.string()
    .test('saleTaxNo', 'Invalid Sales Tax No', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(10, 'Invalid Sales Tax No'),

  authorizedPerson: yup.string()
    .test('authorizedPerson', 'Invalid Authorized Person Name', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(20, 'Max name length is 20.'),

  mobileNo: yup.string()
    .required('Mobile number is required.')
    .matches(/^[0-9]{10,13}$/, 'Invalid Mobile Number'),



  faxNo: yup.string()
    .test('faxNo', 'Invalid FAX number', value => {
      if (!value) return true;  // allow empty
      return /^[0-9]{1,13}$/.test(value);
    }),

  officeNo: yup.string()
    .test('officeNo', 'Invalid Office Number', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(13, 'Invalid Office Number'),

  tinNo: yup.string()
    .test('tinNo', 'Invalid TIN number', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(10, 'Invalid TIN number'),

  groupMid: yup.string()
    .optional()
      .max(15, 'Group MID should be max 15 characters.'),

  microAtmStatus: yup.string()
    .notOneOf(['-1'], 'Please select a valid Master Type'),

  walletBalance: yup.string()
    .test('walletBalance', 'Invalid Wallet Balance', value => {
      if (!value) return true;  // allow empty
      return /^[0-9]+(\.[0-9]{1,10})?$/.test(value);
    })
    .max(10, 'Invalid Wallet Balance'),

  walletAccountNo: yup.string()
    .test('walletAccountNo', 'Invalid Wallet Account Number', value => {
      if (!value) return true;  // allow empty
      return /^[a-zA-Z0-9]{9,32}$/.test(value);
    }),
});

const merchantSchema = yup.object().shape({
  referenceId: optionalWithPattern("referenceId", /^[a-zA-Z0-9]{0,5}$/, 'Invalid Reference Code'),

  referenceCompanyName: optionalWithPattern("referenceCompanyName", /^[a-zA-Z0-9!@#$&()-`.+,/" ]*$/, 'Please Enter Valid Reference Company Name')
    .max(50, 'Please Enter Valid Reference Company Name'),

  ownerName: yup.string()
    .required('Owner name is required.')
    .max(50, 'Invalid Owner Name'),

  pincode: optionalWithPattern("ownerName", /^[0-9]{6}$/, 'Invalid Pin Code'),

  commissionOnDebit: optionalWithPattern("commissionOnDebit", /^[0-9]+(\.[0-9]{0,2})?%?$/, 'Invalid Commission On Debit Value'),

  commissionOnCredit: optionalWithPattern("commissionOnCredit", /^[0-9]+(\.[0-9]{0,2})?%?$/, 'Invalid Commission On Credit Value'),

  senderId: optionalWithPattern("senderId", /^[0-9]{6}$/, 'Invalid Sender Id'),

  mid: yup.string()
    .required('Merchant id is required.')
    .max(15, 'Merchant Id should be min/max 15 characters.'),

  companyName: yup.string()
    .required('Registered Business Name is required.')
    .max(50, 'Invalid Registered Business Name'),

  typeEstablishment: yup.string()
    .notOneOf(['', '-1'], 'Please select a valid Type of Entity'),

  address: yup.string()
    .max(200, 'Address length exceeds the limit'),

  addressRes: yup.string()
    .max(200, 'Address length exceeds the limit'),

  pinCode: yup.string()
  .optional()
    .max(6, 'Zip Code should be max 6 characters.'),

  mccCode: yup.string()
    .notOneOf(['', '-1'], 'Please select a valid Merchant Category Code'),

  abn: yup.string()
    .test('abn', 'Invalid ABN', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(30, 'Max length of ABN should be 30.'),

  acn: yup.string()
    .test('acn', 'Invalid ACN', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(30, 'Max length of ACN should be 30.'),

  establishmentYrs: yup.string()
    .test('establishmentYrs', 'Invalid Year. Please use the format XXXX', value => {
      if (!value) return true;  // allow empty
      return /^[0-9]{4}$/.test(value);
    }),

  saleTaxNo: yup.string()
    .test('saleTaxNo', 'Invalid Sales Tax No', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(10, 'Invalid Sales Tax No'),

  authorizedPerson: yup.string()
    .test('authorizedPerson', 'Invalid Authorized Person Name', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(20, 'Max name length is 20.'),

  mobileNo: yup.string()
    .required('Mobile number is required.')
    .matches(/^[0-9]{10,13}$/, 'Invalid Mobile Number'),



  faxNo: yup.string()
    .test('faxNo', 'Invalid FAX number', value => {
      if (!value) return true;  // allow empty
      return /^[0-9]{1,13}$/.test(value);
    }),

  officeNo: yup.string()
    .test('officeNo', 'Invalid Office Number', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(13, 'Invalid Office Number'),

  tinNo: yup.string()
    .test('tinNo', 'Invalid TIN number', value => {
      if (!value) return true;  // allow empty
      return /^([a-zA-Z0-9]+ )+[a-zA-Z0-9]+$|^[a-zA-Z0-9]+$/.test(value);
    })
    .max(10, 'Invalid TIN number'),

  groupMid: yup.string()
    .optional()
    .max(15, 'Group MID should be max 15 characters.'),

  microAtmStatus: yup.string()
    .notOneOf(['-1'], 'Please select a valid Master Type'),

  walletBalance: yup.string()
    .test('walletBalance', 'Invalid Wallet Balance', value => {
      if (!value) return true;  // allow empty
      return /^[0-9]+(\.[0-9]{1,10})?$/.test(value);
    })
    .max(10, 'Invalid Wallet Balance'),

  walletAccountNo: yup.string()
    .test('walletAccountNo', 'Invalid Wallet Account Number', value => {
      if (!value) return true;  // allow empty
      return /^[a-zA-Z0-9]{9,32}$/.test(value);
    }),

});

export { merchantSchema, merchantSchemaStep1, merchantSchemaStep2, merchantSchemaStep3 };

